import { useDroppable } from '@dnd-kit/core';

const START_HOUR = 0;
const END_HOUR = 24;
const HOURS = Array.from({ length: END_HOUR - START_HOUR }).map((_, i) => START_HOUR + i);
const BORDER = '#f7f7f7';
const HOUR_HEIGHT = 35; // Altura consistente com o calendário principal

export const DayColumn = ({ dayIndex, children }: { dayIndex: number; children?: React.ReactNode }) => {
  const { isOver, setNodeRef } = useDroppable({ id: `day-${dayIndex}` });
  return (
    <div
      ref={setNodeRef}
      style={{
        position: 'relative',
        minHeight: HOURS.length * HOUR_HEIGHT, // Usar altura consistente
        background: '#fff',
      }}
    >
      {HOURS.map((h) => (
        <div
          key={`hour-line-${dayIndex}-${h}`}
          style={{
            position: 'absolute',
            top: (h - START_HOUR) * HOUR_HEIGHT, // Usar altura consistente
            left: 0,
            right: 0,
            height: 1,
            borderTop: `1px solid ${BORDER}`,
          }}
        />
      ))}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          background: isOver ? 'rgba(22, 119, 255, 0.06)' : 'transparent',
        }}
      />
      {children}
    </div>
  );
};
